// extracted by mini-css-extract-plugin
export default {"geocalligraphy":"styles_geocalligraphy__A6XOH","cover":"styles_cover__3vYDL","cover__img":"styles_cover__img__sMcMS","text":"styles_text__CVn3q"};